import { useParams } from 'react-router-dom'

/**
 * Overloading the react router useParams hook to type path params as required
 */
export const useRequiredParams = <T extends Record<string, unknown>>() => useParams() as T
